var React = require('react');

function RightArrowWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M16.707 7.293l-1.414 1.414L17.586 11H2v2h15.586l-2.293 2.293 1.414 1.413L21.414 12z","key":1})]));
}

RightArrowWhite.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RightArrowWhite;

RightArrowWhite.default = RightArrowWhite;
